module.exports = __webpack_public_path__ + "assets/sendgrid.3d8280bf.svg";